
import TextEditor from '@/components/UI/Editor/TextEditor.vue'
export default {
  // eslint-disable-next-line vue/component-definition-name-casing
  name: 'v-custom-component',
  components: { TextEditor },
  props: ['type', 'value', 'obj'],
  computed: {
    rules() {
      return [this.value || this.$t('required')]
    },
    input: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }, // listen to @input="handler"
    },
  },
}
